(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mega-menu_custom"] && !Shopify.designMode) return;
  try {
    // Variables for debouncing and timeout management
    let megaMenuTimeouts = new Map();
    let activeMenuTimeout = null;
    
    // Function to clear all menu hover states
    function clearAllMenuHover(excludeElement = null) {
        document.querySelectorAll('.ms-mega-menu-li.hover').forEach(item => {
            if (item !== excludeElement) {
                item.classList.remove('hover');
            }
        });
    }
    
    // Function to handle menu item hover with debouncing
    function handleMenuItemHover(menuItem, shouldHover) {
        const menuId = menuItem.dataset.menuId || Math.random().toString(36);
        menuItem.dataset.menuId = menuId;
        
        // Clear existing timeout for this menu item
        if (megaMenuTimeouts.has(menuId)) {
            clearTimeout(megaMenuTimeouts.get(menuId));
            megaMenuTimeouts.delete(menuId);
        }
        
        if (shouldHover) {
            // Immediate hover activation
            clearAllMenuHover(menuItem);
            menuItem.classList.add('hover');
        } else {
            // Delayed hover removal (only if mouse truly left the area)
            const timeout = setTimeout(() => {
                menuItem.classList.remove('hover');
                megaMenuTimeouts.delete(menuId);
            }, 150); // 150ms delay before closing
            
            megaMenuTimeouts.set(menuId, timeout);
        }
    }
    
    // Enhanced menu item event handling
    document.addEventListener('DOMContentLoaded', function() {
        document.querySelectorAll('.ms-mega-menu-li').forEach(item => {
            
            // Mouse enter: Show menu immediately
            item.addEventListener('mouseenter', function(e) {
                e.stopPropagation();
                handleMenuItemHover(this, true);
            });
            
            // Mouse leave: Delay hiding to prevent flickering
            item.addEventListener('mouseleave', function(e) {
                e.stopPropagation();
                
                // Check if mouse is moving to the mega menu content
                const rect = this.getBoundingClientRect();
                const megaMenuContainer = this.querySelector('.ms-mega-menu-inner-container');
                
                if (megaMenuContainer) {
                    const containerRect = megaMenuContainer.getBoundingClientRect();
                    
                    // If mouse is moving towards or into the mega menu, don't close
                    if (e.clientX >= rect.right - 10 && e.clientX <= containerRect.right + 10 &&
                        e.clientY >= containerRect.top - 10 && e.clientY <= containerRect.bottom + 10) {
                        return;
                    }
                }
                
                handleMenuItemHover(this, false);
            });
        });
        
        // Handle mega menu containers
        document.querySelectorAll('.ms-mega-menu-inner-container').forEach(container => {
            container.addEventListener('mouseenter', function(e) {
                e.stopPropagation();
                const parentMenuItem = this.closest('.ms-mega-menu-li');
                if (parentMenuItem) {
                    handleMenuItemHover(parentMenuItem, true);
                }
            });
            
            container.addEventListener('mouseleave', function(e) {
                e.stopPropagation();
                const parentMenuItem = this.closest('.ms-mega-menu-li');
                if (parentMenuItem) {
                    handleMenuItemHover(parentMenuItem, false);
                }
            });
        });
        
        // Handle the main mega menu container
        document.querySelectorAll('.ms-mega-menu').forEach(megaMenu => {
            megaMenu.addEventListener('mouseleave', function(e) {
                // Clear all hovers when completely leaving the mega menu area
                const rect = this.getBoundingClientRect();
                const safeZone = 20; // 20px safe zone around menu
                
                // Only close if mouse truly left the mega menu bounds (with safe zone)
                if (e.clientX < rect.left - safeZone || e.clientX > rect.right + safeZone ||
                    e.clientY < rect.top - safeZone || e.clientY > rect.bottom + safeZone) {
                    
                    setTimeout(() => {
                        clearAllMenuHover();
                    }, 200); // Slightly longer delay for main menu
                }
            });
            
            // Also handle mouseenter to cancel any pending close actions
            megaMenu.addEventListener('mouseenter', function(e) {
                // Clear any pending timeouts when re-entering the menu area
                megaMenuTimeouts.forEach((timeout, menuId) => {
                    clearTimeout(timeout);
                    megaMenuTimeouts.delete(menuId);
                });
            });
        });
        
        // Handle parent menu list items (the main navigation items that trigger mega menus)
        document.querySelectorAll('.menu-list__list-item').forEach(parentItem => {
            const megaMenu = parentItem.querySelector('.ms-mega-menu');
            if (megaMenu) {
                parentItem.addEventListener('mouseleave', function(e) {
                    // Check if mouse is leaving towards a safe direction
                    const rect = this.getBoundingClientRect();
                    const isLeavingDownwards = e.clientY > rect.bottom + 10;
                    const isLeavingToSides = e.clientX < rect.left - 10 || e.clientX > rect.right + 10;
                    const isLeavingUpwards = e.clientY < rect.top - 10;
                    
                    // Only close if clearly moving away from menu area
                    if (isLeavingUpwards || (isLeavingToSides && !isLeavingDownwards)) {
                        setTimeout(() => {
                            clearAllMenuHover();
                        }, 100);
                    }
                });
            }
        });

        // Initialize mega menu content and set first menu item as active
        // This needs to run after a small delay to ensure all DOM elements are properly rendered
        setTimeout(() => {
            document.querySelectorAll('.ms-mega-menu').forEach(megaMenu => {
                const firstMenuItem = megaMenu.querySelector('.ms-mega-menu-li:first-child');
                if (firstMenuItem) {
                    firstMenuItem.classList.add('hover');
                }
            });
        }, 50);
        
        // Also handle when new mega menus are dynamically added
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === 1) { // Element node
                        const megaMenus = node.classList && node.classList.contains('ms-mega-menu') 
                            ? [node] 
                            : node.querySelectorAll ? node.querySelectorAll('.ms-mega-menu') : [];
                        
                        megaMenus.forEach(megaMenu => {
                            const firstMenuItem = megaMenu.querySelector('.ms-mega-menu-li:first-child');
                            if (firstMenuItem && !firstMenuItem.classList.contains('hover')) {
                                firstMenuItem.classList.add('hover');
                            }
                        });
                    }
                });
            });
        });
        
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        
        document.querySelectorAll('.ms-mega-menu-inner').forEach(container => {
            const firstCategory = container.querySelector('.ms-mega-menu-inner-grand-li[data-category="1"]');
            if (firstCategory) {
                firstCategory.classList.add('active');
                const firstSubGroup = container.querySelector('.ms-mega-menu-subcategory-group[data-parent="1"]');
                if (firstSubGroup) {
                    firstSubGroup.classList.add('active');
                }
            }
            
            initializeSeparatorVariables(container);
            
            calculateAllColumnWidths(container);
            
            updateSeparators(container);
        });
    });
    
    function initializeSeparatorVariables(container) {
        container.style.setProperty('--column1-width', '280px');
    }
    
    
    function calculateAllColumnWidths(container) {
        const column1 = container.querySelector('.ms-mega-menu-inner-grand-ul');
        let column1MaxWidth = 0;
        
        if (column1) {
            const parentLinks = column1.querySelectorAll('.ms-mega-menu-inner-grand-li-a span');
            parentLinks.forEach(link => {
                const textLength = link.textContent.length;
                const estimatedWidth = textLength * 8 + 80;
                if (estimatedWidth > column1MaxWidth) {
                    column1MaxWidth = estimatedWidth;
                }
            });
        }
        
        column1MaxWidth = Math.max(column1MaxWidth, 250);
        
        const column1Width = column1MaxWidth + 30;
        container.style.setProperty('--column1-width', column1Width + 'px');
        
        const separator1Left = column1Width - 15;
        
        container.style.setProperty('--separator1-left', separator1Left + 'px');
    }
    
    function updateSeparators(container) {
        const column1 = container.querySelector('.ms-mega-menu-inner-grand-ul');
        const hasColumn1Content = column1 && column1.children.length > 0;
        
        const column3 = container.querySelector('.ms-mega-menu-column-3');
        const hasColumn3Content = column3 && column3.querySelectorAll('img').length > 0;
        
        if (hasColumn1Content && hasColumn3Content) {
            container.style.setProperty('--show-separator-1', 'block');
        } else {
            container.style.setProperty('--show-separator-1', 'none');
        }
        
    }

    document.querySelectorAll('.ms-mega-menu-inner-grand-li').forEach(item => {
        item.addEventListener('mouseenter', function () {
            const container = this.closest('.ms-mega-menu-inner');
            
            const allMainCategories = container.querySelectorAll('.ms-mega-menu-inner-grand-li');
            allMainCategories.forEach(category => {
                category.classList.remove('active');
            });
            
            const allSubGroups = container.querySelectorAll('.ms-mega-menu-subcategory-group');
            allSubGroups.forEach(group => {
                group.classList.remove('active');
            });
            
            this.classList.add('active');
            
            const categoryIndex = this.getAttribute('data-category');
            const correspondingSubGroup = container.querySelector(`.ms-mega-menu-subcategory-group[data-parent="${categoryIndex}"]`);
            if (correspondingSubGroup) {
                correspondingSubGroup.classList.add('active');
            }
            
            updateSeparators(container);
            calculateAllColumnWidths(container);
        });
    });
    
    document.querySelectorAll('.ms-mega-menu-inner').forEach(container => {
        container.addEventListener('mouseleave', function () {
            const allSubGroups = this.querySelectorAll('.ms-mega-menu-subcategory-group');
            allSubGroups.forEach(group => {
                group.classList.remove('active');
            });
            
            const allMainCategories = this.querySelectorAll('.ms-mega-menu-inner-grand-li');
            allMainCategories.forEach(category => {
                category.classList.remove('active');
            });
            
            const firstCategory = this.querySelector('.ms-mega-menu-inner-grand-li[data-category="1"]');
            if (firstCategory) {
                firstCategory.classList.add('active');
                const firstSubGroup = this.querySelector('.ms-mega-menu-subcategory-group[data-parent="1"]');
                if (firstSubGroup) {
                    firstSubGroup.classList.add('active');
                }
            }
        });
    });

    document.addEventListener('DOMContentLoaded', function() {
            const simpleDropdown = document.querySelector('.ms-simple-dropdown-list');
            if (simpleDropdown) {
                const container = simpleDropdown.closest('.menu-list__submenu-inner');
                if (container) {
                    container.classList.add('ms-simple-dropdown-container');
                }
            }
        });
        
        function optimizeImageSizes() {
            const megaMenuImages = document.querySelectorAll('.ms-mega-menu-column-3 img');
            
            megaMenuImages.forEach(img => {
                const container = img.closest('.ms-mega-menu-column-3');
                const megaMenuContainer = img.closest('.ms-mega-menu');
                if (container && megaMenuContainer) {
                    const containerRect = container.getBoundingClientRect();
                    const megaMenuRect = megaMenuContainer.getBoundingClientRect();
                    const containerWidth = containerRect.width;
                    const containerHeight = megaMenuRect.height - 20;
                    
                    const imgAspectRatio = img.naturalWidth / img.naturalHeight;
                    const containerAspectRatio = containerWidth / containerHeight;
                    
                    let optimalWidth, optimalHeight;
                    
                    if (imgAspectRatio > containerAspectRatio) {
                        optimalWidth = containerWidth;
                        optimalHeight = containerWidth / imgAspectRatio;
                    } else {
                        optimalHeight = containerHeight;
                        optimalWidth = containerHeight * imgAspectRatio;
                    }
                    img.style.width = optimalWidth + 'px';
                    img.style.height = optimalHeight + 'px';
                    
                    console.log('Optimized image size:', {
                        original: { width: img.naturalWidth, height: img.naturalHeight },
                        megaMenu: { height: megaMenuRect.height },
                        container: { width: containerWidth, height: containerHeight },
                        optimal: { width: optimalWidth, height: optimalHeight }
                    });
                }
            });
        }
        
        document.addEventListener('DOMContentLoaded', optimizeImageSizes);
        window.addEventListener('resize', optimizeImageSizes);
        
        setTimeout(optimizeImageSizes, 500);
        
        // Additional initialization for mega menus that might be loaded later
        setTimeout(() => {
            document.querySelectorAll('.ms-mega-menu').forEach(megaMenu => {
                const firstMenuItem = megaMenu.querySelector('.ms-mega-menu-li:first-child');
                if (firstMenuItem && !firstMenuItem.classList.contains('hover')) {
                    firstMenuItem.classList.add('hover');
                }
            });
        }, 200);
        
        // Force initialization on window load as well
        window.addEventListener('load', () => {
            setTimeout(() => {
                document.querySelectorAll('.ms-mega-menu').forEach(megaMenu => {
                    const firstMenuItem = megaMenu.querySelector('.ms-mega-menu-li:first-child');
                    if (firstMenuItem && !firstMenuItem.classList.contains('hover')) {
                        firstMenuItem.classList.add('hover');
                    }
                });
            }, 100);
        });
  } catch(e) { console.error(e); }
})();

})();
